const
    elSearch = document.getElementById('search-input'),
    elModalSearch = document.getElementById('search-modal-input'),
    elIconSearch = document.getElementById('search-icon');

document.body.addEventListener('click', e => {
    const searchEl = document.getElementById('search-result');
    if (!_.isNull(searchEl) && e.target !== searchEl) {
        searchEl.classList.add('hidden');

    }
})

addEventListener('input', e => {

    if (e.target === elSearch || e.target === elModalSearch) {
        const
            search = e.target.value.trim(),
            url = e.target.getAttribute('data-search-url'),
            snippet = e.target === elSearch
                ? 'searchInlineResult'
                : 'searchModalResult';

        if (search.length >= 3) {
            delay(() => {
                let body = ID["snippet-search-searchModalResult"];
                ID.searchLoading.style.display = "block";
                let result = body.querySelector(".search-result");
                if(result) result.innerHTML = "";
                let pc = body.querySelector(".product-count");
                if(pc) pc.innerHTML = "";
                naja.makeRequest('POST', url, {
                    search: search,
                    snippet: snippet
                }, {
                    history: false,
                    spinner: false
                }).then(r => {
                    const searchResultEl = document.getElementById('search-result');
                    if (!_.isNull(searchResultEl)) {
                        searchResultEl.classList.remove('hidden')

                    }
                });
            }, 300)

        }

    }
})

const delay = (() => {
    let timer = 0;
    return (callback, ms) => {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    }
})();

